import {useFormContext, useFormState} from "react-hook-form";
import {useContext} from "react";
import {ProductFormContext} from "@/lib/product-form-context";

export const FormError = () => {
  const { control } = useFormContext();
  const { errors } = useFormState({
    control,
    name: 'products'
  });

  const productFormContext = useContext(ProductFormContext);

  if(errors.products && Array.isArray(errors.products) && errors.products?.[productFormContext]) {
    return <div className="text-sm py-1 text-error">{errors.products[productFormContext].message}</div>;
  }

  return null;
}